import { render, staticRenderFns } from "./BeautyServicesRendered.vue?vue&type=template&id=26078bb2&scoped=true"
import script from "./BeautyServicesRendered.vue?vue&type=script&lang=js"
export * from "./BeautyServicesRendered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26078bb2",
  null
  
)

export default component.exports